import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";
import { Box, IconButton, Input, Typography } from "@mui/material";
import axios from "axios";
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import DataTableItem from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../../utils/constants";
import localizationStrings from "../../utils/localizations";
import "../Employees.css";
import VisibilityIcon from "@mui/icons-material/Visibility";
// const columns = ;

export default function DataTable() {
  const [, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [search, setSearch] = useState('');
  const search = useRef("");
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();
  const [exporting, setExporting] = useState(false);
  const [sortBy, setSortBy] = useState("LeavingDate");
  const [sortDir, setSortDir] = useState("desc");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const sortChange = useRef(false);
  const [, reload] = useState({});
  const [exportQuery, setExportQuery] = useState("");

  const getEmployees = useCallback(
    async (
      {
        sortByParam = sortBy,
        sortDirParam = sortDir,
        searchParam = search.current,
        page = currentPage,
        silent = false,
        setLoading1 = setLoading,
      } = {
        sortByParam: sortBy,
        sortDirParam: sortDir,
        searchParam: search.current,
        silent: false,
        page: currentPage,
        setLoading1: setLoading,
      },
    ) => {
      if (!silent) setLoading1(true);
      try {
        const data = await axios.get(baseUrl + "getAllTripsWithEmployees", {
          params: {
            sortBy: sortByParam,
            sortDir: sortDirParam,
            search: searchParam || undefined,
            page,
          },
        });
        if (data.data.status) {
          setData(data.data.result);
          setFilteredData(data.data.result);
          setTotalCount(data.data.totalCount);
          setExportQuery(data.data.exportQuery);
        }
        // console.log('employees', data.data.result);
        if (!silent) setLoading1(false);
        setTimeout(() => {
          // document.getElementsByClassName('rdt_Pagination')[0].dir = 'ltr';
          // document.getElementsByClassName('rdt_Pagination')[0].children[0].innerText = localizationStrings.RowsPerPage;
        }, 1000);
      } catch (e) {
        if (!silent) setLoading1(false);
        console.warn(e);
      }
    },
    [currentPage, sortBy, sortDir],
  );
  useEffect(() => {
    getEmployees();
    const int = setInterval(() => {
      getEmployees({ silent: true });
    }, 30 * 1000);
    return () => clearInterval(int);
  }, [getEmployees]);

  const onSort = (selectedColumn, sortDirection) => {
    sortChange.current = true;
    if (selectedColumn.id != sortBy || sortDirection != sortDir) {
      console.log(selectedColumn.id);
      setSortBy(selectedColumn.id);
      setSortDir(sortDirection);
      console.log("sortChange");
      getEmployees({
        sortByParam: selectedColumn.id,
        sortDirParam: sortDirection /* silent: true */,
      });
    }
    // console.log(selectedColumn, sortDirection, sortedRows);
  };

  const onPageChange = (page) => {
    page = page - 1;
    if (sortChange.current) {
      sortChange.current = false;
      return;
    }
    if (currentPage != page) {
      setCurrentPage(page);
      console.log("page Change", page);
      getEmployees({ page });
    }
  };

  function secondsToDhms(seconds) {
    seconds = Number(seconds);
    var sign = seconds < 0 ? "-" : "";
    seconds = Math.abs(seconds);
    var d = Math.floor(seconds / (3600 * 24));
    var h = Math.floor((seconds % (3600 * 24)) / 3600);
    var m = Math.floor((seconds % 3600) / 60);

    var dDisplay = d > 0 ? d + ` ${localizationStrings.days} ` : "";
    var hDisplay = h > 0 ? h + ` ${localizationStrings.hrs} ` : "";
    var mDisplay = m > 0 && d <= 0 ? m + ` ${localizationStrings.min} ` : "";
    return (sign + dDisplay + hDisplay + mDisplay).trim() || `0 ${localizationStrings.min}`;
  }

  const formatTime = (mins) => {
    return secondsToDhms(mins * 60);
  };

  // if (loading && !search.current) {
  //   return (
  //     <div className='tracking-container' style={{ alignItems: 'center', justifyContent: 'center' }}>
  //       <div className='loader'></div>
  //     </div>
  //   );
  // }
  // if (data.length === 0 && !search.current) {
  //   return (
  //     <div className='tracking-container' style={{ alignItems: 'center', justifyContent: 'center' }}>
  //       <h3 style={{ textAlign: 'center' }}>{localizationStrings.NoEmployees}</h3>
  //     </div>
  //   );
  // }

  const handleSearch = (searchEmpty = false) => {
    getEmployees({ searchParam: searchEmpty ? "" : search.current });
  };

  const exportPdf = async (type) => {
    setExporting(true);
    try {
      const data = await axios.post(baseUrl + "exportExcel", {
        query: exportQuery,
        type,
      });
      // console.log(data.data);
      if (data.data.status) {
        await new Promise((r) => setTimeout(r, 1000));
        var a = document.createElement("A");
        a.href = data.data.downloadUrl;
        a.download = true;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
      setExporting(false);
    } catch (e) {
      setExporting(false);
      console.warn(e);
    }
  };

  const formatDateTime = (time, doUtc = true) => {
    if (doUtc) {
      return moment(time).utc().format("DD/MM/YYYY HH:mm");
    } else {
      return moment(time).format("DD/MM/YYYY HH:mm");
    }
  };

  // console.log(exportQuery);

  return (
    <div style={{ height: "calc(100vh - 56px)", width: "100%", padding: 30 }}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSearch();
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            mb: "15px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
              onClick={() => (exporting ? null : exportPdf("xlsx"))}
            >
              <DownloadIcon fontSize="11px" />
              <Typography sx={{ fontSize: 12, fontWeight: "500", marginLeft: "5px" }}>
                {exporting ? localizationStrings.Exporting + "..." : localizationStrings.ExportToExcel}
              </Typography>
            </Box>
            {!exporting && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <DownloadIcon fontSize="11px" />
                <Typography
                  sx={{ fontSize: 12, fontWeight: "500", marginLeft: "5px" }}
                  onClick={() => (exporting ? null : exportPdf("pdf"))}
                >
                  {localizationStrings.ExportToPdf}
                </Typography>
              </Box>
            )}
          </Box>
          {/* <div style={{ flex: 1, display: 'flex' }} /> */}
          <Input
            style={{ backgroundColor: "#fff" }}
            placeholder={localizationStrings.Search}
            color="primary"
            value={search.current}
            onChange={(e) => {
              search.current = e.nativeEvent.target.value;
              reload({});
            }}
            endAdornment={
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() => {
                    search.current = "";
                    handleSearch(true);
                  }}
                >
                  <CloseIcon />
                </IconButton>
                <IconButton type="submit" onClick={() => handleSearch()}>
                  <SearchIcon />
                </IconButton>
              </Box>
            }
          />
        </Box>
      </form>
      {loading ? (
        <div
          style={{
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
          }}
        >
          <div className="loader"></div>
        </div>
      ) : (
        <DataTableItem
          data={filteredData}
          columns={[
            {
              selector: (row) => row.Employee_No,
              name: <div>{localizationStrings.EmployeeNo}</div>,
              sortable: true,
              grow: 1,
              wrap: true,
              id: "Employee_No",
            },
            {
              selector: (row) => decodeURIComponent(row.Full_Name),
              name: <div>{localizationStrings.Name}</div>,
              sortable: true,

              grow: 1,
              wrap: true,
              id: "Full_Name",
            },
            {
              selector: (row) => row.Mobile_No,
              name: <div>{localizationStrings.MobileNo}.</div>,
              sortable: true,
              grow: 1,
              wrap: true,
              id: "Mobile_No",
            },
            {
              selector: (row) => row.LeavingNo,
              name: <div>{localizationStrings.LeavingNo}</div>,
              sortable: true,
              grow: 1,
              wrap: true,
              id: "LeavingNo",
            },
            {
              selector: (row) => formatDateTime(row.LeavingDate),
              name: <div>{localizationStrings.LeavingDate}</div>,
              sortable: true,
              grow: 1,
              wrap: true,
              id: "LeavingDate",
            },
            {
              selector: (row) => formatDateTime(row.created_at, false),
              name: <div>{localizationStrings.StationArriveDate}</div>,
              sortable: true,
              grow: 1,
              wrap: true,
              id: "created_at",
            },
            // {
            //   selector: (row) => row.HouseName,
            //   name: <div>{localizationStrings.LocationName}</div>,
            //   sortable: true,
            //   grow: 1,
            //   wrap: true,
            // },
            {
              selector: (row) => row.CompanyName,
              name: <div>{localizationStrings.CompanyName}</div>,
              sortable: true,
              grow: 1,
              wrap: true,
              id: "CompanyName",
            },
            // {
            //   // Bus Operting Id, plate number, naqaba number, path name
            // },
            {
              selector: (row) => row.BusNo,
              name: <div>{localizationStrings.BusNaqabaNumber}</div>,
              sortable: true,
              grow: 1,
              wrap: true,
              id: "BusNo",
            },
            {
              selector: (row) => row.BusPlant,
              name: <div>{localizationStrings.BusPlateNo}</div>,
              sortable: true,
              grow: 1,
              wrap: true,
              id: "BusPlant",
            },
            {
              selector: (row) => row.biOperatingCardNo,
              name: <div>{localizationStrings.BusOperatingId}</div>,
              sortable: true,
              grow: 1,
              wrap: true,
              id: "biOperatingCardNo",
            },
            {
              selector: (row) => row.pathName,
              name: <div>{localizationStrings.PathName}</div>,
              sortable: true,
              grow: 1,
              wrap: true,
              id: "pathName",
            },

            {
              selector: (row) => row.destination_count,
              name: <div>{localizationStrings.NumberOfDestinations}</div>,
              sortable: true,
              grow: 1,
              wrap: true,
              id: "destination_count",
            },
            {
              selector: (row) =>
                row.StartDatetime
                  ? formatTime(
                      moment(row.StartDatetime).diff(
                        moment(row.created_at).subtract(new Date().getTimezoneOffset(), "minute"),
                        "minute",
                      ),
                    )
                  : localizationStrings.NotStarted,
              name: <div>{localizationStrings.TimeToStart}</div>,
              sortable: false,
              grow: 1,
              wrap: true,
            },
            {
              selector: (row) =>
                row.StartDatetime ? formatDateTime(row.StartDatetime) : localizationStrings.NotStarted,
              name: <div>{localizationStrings.StartDate}</div>,
              sortable: true,
              grow: 1,
              wrap: true,
              id: "StartDatetime",
            },
            {
              selector: (row) => (row.EndDatetime ? formatDateTime(row.EndDatetime) : localizationStrings.NotEnded),
              name: <div>{localizationStrings.ArriveDate}</div>,
              sortable: true,
              grow: 1,
              wrap: true,
              id: "EndDatetime",
            },
            {
              selector: (row) =>
                row.StartDatetime
                  ? row.EndDatetime
                    ? formatTime(
                        moment(row.StartDatetime)
                          .utc()
                          .diff(row.EndDatetime ? moment(row.EndDatetime).utc() : moment().utc(), "minute") * -1,
                      )
                    : localizationStrings.NotEnded
                  : localizationStrings.NotStarted,
              name: <div>{localizationStrings.TimeToArrive}</div>,
              sortable: false,
              grow: 1,
              wrap: true,
            },
            {
              selector: (row) => (row.PickupTime ? formatDateTime(row.PickupTime) : localizationStrings.NotPickedUp),
              name: <div>{localizationStrings.PickupTime}</div>,
              sortable: true,
              grow: 1,
              id: "PickupTime",
              wrap: true,
            },
            {
              selector: (row) =>
                row.EndDatetime
                  ? row.PickupTime
                    ? formatTime(
                        moment(row.EndDatetime)
                          .utc()
                          .diff(row.PickupTime ? moment(row.PickupTime).utc() : moment().utc(), "minute") * -1,
                      )
                    : localizationStrings.NotPickedUp
                  : localizationStrings.NotEnded,
              name: <div>{localizationStrings.TimeToPickup}</div>,
              sortable: false,
              grow: 1,
              wrap: true,
            },
            {
              selector: (row) => (
                <div>
                  {
                    <IconButton
                      type="submit"
                      onClick={() => navigate("/dashboard-home/employees-trips/" + row.LeavingNo)}
                    >
                      <VisibilityIcon />
                    </IconButton>
                  }
                </div>
              ),
              name: <div>{localizationStrings.Actions}</div>,
              sortable: false,
              grow: 3,
              wrap: true,
            },
          ]}
          highlightOnHover
          fixedHeader
          sortServer
          defaultSortAsc={sortDir === "asc"}
          defaultSortFieldId={sortBy}
          onSort={onSort}
          onChangePage={onPageChange}
          pagination
          responsive
          paginationPerPage={30}
          paginationRowsPerPageOptions={[30]}
          // pagination
          paginationServer
          paginationTotalRows={totalCount}
          paginationDefaultPage={currentPage + 1}
          // onRowClicked={(row) => navigate(row.LeavingNo)}
          paginationComponent={({ rowsPerPage, rowCount, currentPage, onChangePage, onChangeRowsPerPage }) => (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-end",
                minHeight: 56,
              }}
              dir="ltr"
            >
              <Typography
                sx={{
                  margin: "0 24px",
                  color: "rgba(0, 0, 0, 0.54)",
                  fontSize: "13px",
                }}
              >
                {(currentPage - 1) * rowsPerPage + 1}-
                {currentPage * rowsPerPage > rowCount ? rowCount : currentPage * rowsPerPage} of {rowCount}
              </Typography>
              <div style={{ display: "flex", alignItems: "center" }}>
                <button
                  className="changeButton"
                  type="button"
                  disabled={currentPage === 1}
                  style={{
                    fill: `rgba(0,0,0,${currentPage === 1 ? "0.18" : "0.54"})`,
                    color: `rgba(0,0,0,${currentPage === 1 ? "0.18" : "0.54"})`,
                  }}
                  onClick={() => onChangePage(1)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"></path>
                    <path fill="none" d="M24 24H0V0h24v24z"></path>
                  </svg>
                </button>
                <button
                  className="changeButton"
                  type="button"
                  disabled={currentPage === 1}
                  style={{
                    fill: `rgba(0,0,0,${currentPage === 1 ? "0.18" : "0.54"})`,
                    color: `rgba(0,0,0,${currentPage === 1 ? "0.18" : "0.54"})`,
                  }}
                  onClick={() => onChangePage(currentPage - 1)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
                    <path d="M0 0h24v24H0z" fill="none"></path>
                  </svg>
                </button>
                <button
                  className="changeButton"
                  type="button"
                  disabled={currentPage === Math.ceil(rowCount / rowsPerPage)}
                  style={{
                    fill: `rgba(0,0,0,${currentPage === Math.ceil(rowCount / rowsPerPage) ? "0.18" : "0.54"})`,
                    color: `rgba(0,0,0,${currentPage === Math.ceil(rowCount / rowsPerPage) ? "0.18" : "0.54"})`,
                  }}
                  onClick={() => onChangePage(currentPage + 1)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
                    <path d="M0 0h24v24H0z" fill="none"></path>
                  </svg>
                </button>
                <button
                  className="changeButton"
                  type="button"
                  disabled={currentPage === Math.ceil(rowCount / rowsPerPage)}
                  style={{
                    fill: `rgba(0,0,0,${currentPage === Math.ceil(rowCount / rowsPerPage) ? "0.18" : "0.54"})`,
                    color: `rgba(0,0,0,${currentPage === Math.ceil(rowCount / rowsPerPage) ? "0.18" : "0.54"})`,
                  }}
                  onClick={() => onChangePage(Math.ceil(rowCount / rowsPerPage))}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"></path>
                    <path fill="none" d="M0 0h24v24H0V0z"></path>
                  </svg>
                </button>
              </div>
            </Box>
          )}
          // subHeader
          // subHeaderComponent={

          // }

          style={{ height: "calc(100vh - 56px)" }}
          customStyles={{
            headCells: { style: { backgroundColor: "#E8DABC", color: "#000" } },
            responsiveWrapper: { style: { height: "calc(100vh - 194px)" } },
            tableWrapper: { style: { width: "2000px" } },
          }}
        />
      )}
    </div>
  );
}
